module.exports = __webpack_public_path__ + "img/77.688cc67.png";